import React from "react";
import "./_servicesHightRiseCleaning.scss";

const ServicesHightRiseCleaning = () => {
  return (
    <div className="servicesHightRiseCleaning">
      <div className="servicesHightRiseCleaning__content">
        <div className="servicesHightRiseCleaning__content__row1">
          <h5 className="servicesHightRiseCleaning__content__row1__title">
            Como Contratarnos?
          </h5>
          <ol className="servicesHightRiseCleaning__content__row1__list">
            <li>
              Solicite presupuestos: envie fotos/videos/direccion para búsqueda
              por maps al whatssap: 11 5461 5971/15.5767.4230 o
              info@vidrioslimpios.com.ar.
            </li>
            <li>
              Se coordina fecha y hora de servicio, previo pago de anticipo en
              concepto de reserva de equipos, personal y precio.
            </li>
            <li>
              Se abonará el saldo del servicio eventual al concluir el mismo.
              Los abonos vencen los 5 de cada mes, y se actualizarán
              automáticamente cada 3 meses o por falta de pago después de esta
              fecha. En caso de abonos se reservarán servicios. equipos y precio
              por 3 meses (periodo mínimo de contratación) con la firma del
              presupuesto enviado por mail y pagos a término (antes del 5).
            </li>
          </ol>
        </div>
        <div className="servicesHightRiseCleaning__content__row2">
          <h5 className="servicesHightRiseCleaning__content__row2__title">
            Criterios para las cotizaciones
          </h5>
          <ol className="servicesHightRiseCleaning__content__row2__list">
            <li>
              Superficie expresadas en m2 de la superficie a limpiar (desde
              100m2).
            </li>
            <li>
              Estado del vidrio o superficie ( final de obra: con marcas
              adhesivas, roturas, pintura, obra, silicona, excrementos de
              palomas, calcos, etc).
            </li>
            <li>
              Frecuencias de servicios: eventual ( única vez), Finales de obras
              (calcos, vinilos, polvillo de obra, pintura, restos materiales,
              excremento o tierra) y abonos ( semanal, quincenal, mensual,
              bimestral y trimestral).
            </li>
            <li>
              Tipo de vidrio y complejidades: repartidos, techos, cúpulas,
              cerramientos, superficies rugosas, con rejas, etc.
            </li>
            <li>
              Seguridad: (Accesibilidad al lugar y niveles de riesgos): con
              silleta Accesos a cuerda: anclajes certificados, (cantidad de
              descensos/bajadas/tiradas), escalera, andamios, plataformas
              eléctricas, autoelevadores, extensores, etc.
            </li>
            <li>
              Complementarios: gastos de transporte y logística, zonas alejadas,
              rurales e inaccesibles. Equipo u operario especializado. Estado de
              higiene y salubridad de los lugares de trabajo, etc.
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default ServicesHightRiseCleaning;
